import { render } from "./Switch.vue?vue&type=template&id=3f12ff94"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=3f12ff94&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__